import { SxProps, Theme } from '@mui/material';

export const quantityButtonStyles: SxProps<Theme> = {
    height: '32px',
    width: '32px',
    minWidth: '32px',
    padding: '0',
    boxSizing: 'border-box',
    fontSize: '16px',
    color: '#626262',
    backgroundColor: '#F4F4F4',
    border: '1px solid #DFDFDF',
    '&:hover, &:focus-visible': {
        backgroundColor: '#DFDFDF',
    },
    '&:disabled': {
        color: '#D3D3D3',
        backgroundColor: '#F4F4F4',
    },
};

export const leftButtonStyles: SxProps<Theme> = {
    ...quantityButtonStyles,
    borderRadius: '4px 0 0 4px',
    borderRight: 'none',
};

export const rightButtonStyles: SxProps<Theme> = {
    ...quantityButtonStyles,
    borderRadius: '0 4px 4px 0',
    borderLeft: 'none',
};
